module.exports = __webpack_public_path__ + "static/index/img/baikal-501.660744c2.jpg";